var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-master view-outer home-view-outer pr",class:{'is-fullscreen': _vm.is24Col  }},[_c('div',{staticClass:"left-content"},[_c('top-desc',{on:{"open-account":_vm.openAccountHandle}}),_c('right-bar',{staticClass:"right-content"}),_c('my-mam-account-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }